
import { Component, Vue, Watch } from 'vue-property-decorator';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import markdown from 'spa-ionata-admin/lib/services/markdown';
import Post, { PostProxy } from '../models/Post';

@Component({ components: {} })
export default class extends Vue {
  dataPromise = new ObservedPromise<PostProxy>();

  get slug(): string | undefined {
    return this.$route.params.slug;
  }

  get post(): Post | undefined {
    return this.dataPromise.value?.data || undefined;
  }

  get error() {
    if (this.dataPromise.isError) {
      return this.dataPromise.error;
    }
    if (this.dataPromise.isFinished && !this.post) {
      let { slug } = this;
      if (!slug) {
        slug = '[blank]';
      }
      const maxLength = 50;
      if (slug.length > maxLength) {
        slug = `${slug.substring(0, maxLength)}…`;
      }
      return new Error(`Post '${slug}' not found.`);
    }
    return undefined;
  }

  get content(): string | undefined {
    if (!this.post?.locale) {
      return undefined;
    }
    const { content } = this.post.locale;
    if (!content) {
      return '';
    }
    return markdown(content);
  }

  @Watch('slug', { immediate: true })
  onSlugChanged(slug: string | undefined | null) {
    const promise = Post.where({ slug }).first();
    this.dataPromise = new ObservedPromise(promise);
  }
}
